import { ContactName } from '@uplift/types';
import { useL10n } from '@uplift/hooks';
import { MaskedInput } from '@uplift/ui-v2';
import { Form } from 'formik';
import { useFormStyles } from '../form-styles';

export const PhoneForm = () => {
  const l10n = useL10n();
  const { classes } = useFormStyles();

  return (
    <Form className={classes.formGroup}>
      <MaskedInput
        label={l10n.accountSettings.profile.mobile}
        name={ContactName.mobile}
        fullWidth
        type="phone"
      />
      <MaskedInput
        label={l10n.accountSettings.isOptional(l10n.accountSettings.profile.home)}
        name={ContactName.home}
        fullWidth
        type="phone"
      />
    </Form>
  );
};
